var Articlecategory;

Articlecategory = function(article_category_id, selected_tags) {
  this.selected_tags = selected_tags;
  self.id = article_category_id;
  self.articles = (function(_this) {
    return function(options, callback) {
      options.tag_ids = _this.selected_tags();
      return api.articlecategories.articles.read(self.id, options).done(callback);
    };
  })(this);
  return self;
};

if (api.articlecategories == null) {
  api.add('articlecategories');
}

api.articlecategories.add('articles');

//# sourceMappingURL=articlecategory.js.map
